(() => {
  const stickyEntries = [];
  const updateStickyBars = () => {
    const entries = stickyEntries.filter(entry => entry.form.isConnected);
    let chosen = null;
    const formVisible = entries.some(({form}) => {
      const rect = form.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    });
    if (!formVisible) {
      entries.forEach(entry => {
        if (entry.form.getBoundingClientRect().bottom <= 0) chosen = entry;
      });
    }
    stickyEntries.forEach(entry => { entry.sticky.hidden = entry !== chosen; });
  };
  let stickyFrame = null;
  const scheduleStickyBars = () => {
    if (stickyFrame !== null) return;
    stickyFrame = window.requestAnimationFrame(() => {
      stickyFrame = null;
      updateStickyBars();
    });
  };
  window.addEventListener('scroll', scheduleStickyBars, {passive: true});
  window.addEventListener('resize', scheduleStickyBars);
  window.addEventListener('hashchange', scheduleStickyBars);
  const initReviews = (root) => {
    root.querySelectorAll('[data-cro-reviews]').forEach(section => {
      if (section.dataset.initialized) return;
      const viewport = section.querySelector('[data-cro-review-viewport]');
      const cards = [...section.querySelectorAll('[data-cro-review-card]')];
      const previous = section.querySelector('[data-cro-review-previous]');
      const next = section.querySelector('[data-cro-review-next]');
      const position = section.querySelector('[data-cro-review-position]');
      if (!viewport || !cards.length || !previous || !next || !position) return;
      section.dataset.initialized = 'true';
      const offsets = () => cards.map(card => card.offsetLeft - cards[0].offsetLeft);
      const currentIndex = () => {
        const positions = offsets();
        return positions.reduce((best, value, index) => Math.abs(value - viewport.scrollLeft) < Math.abs(positions[best] - viewport.scrollLeft) ? index : best, 0);
      };
      const update = () => {
        const maximum = viewport.scrollWidth - viewport.clientWidth;
        previous.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= maximum - 2;
        position.textContent = `${currentIndex() + 1} / ${cards.length}`;
      };
      const move = (direction) => {
        const index = Math.max(0, Math.min(cards.length - 1, currentIndex() + direction));
        viewport.scrollTo({left: offsets()[index], behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      viewport.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(viewport);
      update();
    });
  };
  const init = (root = document) => {
    initReviews(root);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style: 'currency', currency: 'EUR'});
    root.querySelectorAll('[data-cro-hero-offer]').forEach(offer => {
      offer.textContent = offer.dataset.label.replaceAll('__PRICE__', money.format(Number(offer.dataset.price) / 100));
    });
    root.querySelectorAll('[data-cro-picker]').forEach((picker) => {
      if (picker.dataset.initialized) return;
      picker.dataset.initialized = 'true';
      const messages = JSON.parse(picker.querySelector('[data-cro-messages]').textContent);
      const cards = [...picker.querySelectorAll('[data-cro-card]')];
      const buttons = [...picker.querySelectorAll('[data-cro-duration]')];
      const directMode = picker.dataset.croMode === 'direct';
      const currency = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style: 'currency', currency: 'EUR'});
      cards.forEach(card => { card.querySelector('.cro-pack-price').textContent = currency.format(Number(card.dataset.price) / 100); });
      cards.forEach(card => {
        const unitPrice = card.querySelector('[data-cro-unit-price]');
        if (unitPrice) unitPrice.textContent = messages.unitPrice.replaceAll('__PRICE__', currency.format(Math.round(Number(card.dataset.price) / Number(card.dataset.packs)) / 100));
      });
      const format = (text, values) => Object.entries(values).reduce((s, [k,v]) => s.replaceAll('__' + k + '__', v), text);
      const set = (selector, value) => { picker.querySelector(selector).textContent = value; };
      const form = picker.querySelector('form');
      const add = picker.querySelector('[name="add"]');
      const sticky = picker.querySelector('[data-cro-sticky]');
      const stickyAdd = picker.querySelector('[data-cro-sticky-add]');
      const syncSticky = () => {
        if (!sticky || !stickyAdd) return;
        sticky.querySelector('[data-cro-sticky-contents]').textContent = picker.querySelector('[data-cro-contents]').textContent;
        sticky.querySelector('[data-cro-sticky-price]').textContent = picker.querySelector('[data-cro-price]').textContent;
        sticky.querySelector('[data-cro-sticky-label]').textContent = picker.querySelector('[data-cro-button-label]').textContent;
        stickyAdd.disabled = add.disabled;
        stickyAdd.setAttribute('aria-busy', String(add.getAttribute('aria-busy') === 'true' || add.classList.contains('loading')));
      };
      if (sticky && stickyAdd) {
        document.body.append(sticky);
        stickyAdd.addEventListener('click', () => { if (!add.disabled) add.click(); });
        new MutationObserver(syncSticky).observe(add, {attributes: true, childList: true, subtree: true, characterData: true});
        stickyEntries.push({form, sticky});
        const updateStickyVisibility = updateStickyBars;
        const visibilityObserver = new IntersectionObserver(updateStickyVisibility);
        visibilityObserver.observe(form);
        updateStickyVisibility();
        const error = picker.querySelector('.product-form__error-message');
        if (error) new MutationObserver(() => {
          if (!error.hidden && error.textContent.trim()) picker.scrollIntoView({block: 'center', behavior: 'smooth'});
        }).observe(error, {attributes: true, childList: true, subtree: true});
      }
      const select = (card, updateUrl = true) => {
        const days = Number(card.dataset.days);
        const packs = Number(card.dataset.packs);
        const tablets = (days + 2) * 2;
        const price = Number(card.dataset.price);
        cards.forEach(c => { c.querySelector('input').checked = c === card; c.hidden = c.dataset.option !== card.dataset.option; });
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.croOption === card.dataset.option)));
        if (directMode) {
          // Compare the same pack quantity, even when a larger pack size is selected.
          const base = cards.find(c => Number(c.dataset.days) === 1 && Number(c.dataset.packs) === packs);
          buttons.forEach(button => {
            const target = cards.find(c => c.dataset.option === button.dataset.croOption && Number(c.dataset.packs) === packs);
            button.disabled = !target || target.dataset.available !== 'true';
            const label = button.querySelector('[data-cro-option-price]');
            if (!target) { label.textContent = messages.unavailable; return; }
            const extra = base && Number(button.dataset.croDuration) !== 1;
            const amount = Number(target.dataset.price) - (extra ? Number(base.dataset.price) : 0);
            label.textContent = (extra && amount >= 0 ? '+' : '') + currency.format(amount / 100);
          });
        }
        picker.querySelector('[data-cro-variant]').value = card.dataset.id;
        picker.querySelector('[data-cro-set-property]').value = format(messages.property, {PACKS:packs, DAYS:days, TABLETS:tablets, TOTAL_TABLETS:packs * tablets});
        picker.querySelectorAll('[data-cro-routine-day]').forEach(day => {day.hidden = Number(day.dataset.croRoutineDay) > days;});
        if (picker.querySelector('[data-cro-routine-total]')) set('[data-cro-routine-total]', format(messages.total, {COUNT:tablets}));
        if (picker.querySelector('[data-cro-pack-count]')) set('[data-cro-pack-count]', format(messages.packCount, {PACKS:packs}));
        set('[data-cro-contents]', format(messages.contents, {PACKS:packs, DAYS:days, TABLETS:tablets, TOTAL_TABLETS:packs * tablets}));
        const shipping = price >= 2500 ? 0 : 395;
        set('[data-cro-price]', currency.format(price / 100));
        const addPrice = picker.querySelector('[data-cro-add-price]');
        if (addPrice) addPrice.textContent = currency.format(price / 100);
        set('[data-cro-shipping]', shipping ? format(messages.shipping, {TOTAL:currency.format((price + shipping) / 100)}) : messages.freeShipping);
        const available = card.dataset.available === 'true';
        picker.querySelector('[name="add"]').disabled = !available;
        set('[data-cro-button-label]', available ? messages.add : messages.unavailable);
        syncSticky();
        const url = new URL(location.href);
        url.searchParams.set('variant', card.dataset.id);
        if (updateUrl) history.replaceState(history.state, '', url);
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const current = cards.find(c => c.querySelector('input').checked);
        const matches = cards.filter(c => c.dataset.option === button.dataset.croOption);
        const next = directMode
          ? matches.find(c => c.dataset.packs === current?.dataset.packs && c.dataset.available === 'true')
          : matches.find(c => c.dataset.packs === current?.dataset.packs && c.dataset.available === 'true') || matches.find(c => c.dataset.available === 'true') || matches[0];
        if (next) select(next);
      }));
      cards.forEach(card => card.querySelector('input').addEventListener('change', () => select(card)));
      const requestedVariant = new URL(location.href).searchParams.get('variant');
      const selected = cards.find(c => c.dataset.id === requestedVariant) || cards.find(c => c.querySelector('input').checked) || cards[0];
      if (selected) select(selected, false);
      const morePacks = picker.querySelector('[data-cro-more-packs]');
      if (morePacks && Number(selected?.dataset.packs) > 2) morePacks.open = true;
      const routine = picker.querySelector('.cro-routine');
      if (routine && location.hash === '#' + routine.id) routine.open = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('click', event => {
    const usageLink = event.target.closest('a[href="#festival-gebruik"], a[data-cro-usage-link]');
    if (usageLink) {
      const routine = document.getElementById(usageLink.getAttribute('href').slice(1));
      if (routine?.classList.contains('cro-routine')) routine.open = true;
    }
  });
})();



